export default function configParams(state = {}, action) {
    return {
      ...state,
    }
  }
  